module.exports = __webpack_public_path__ + "img/zcdbg.78dc9c80.png";